/**
 * Implements a wallet overview section placeholder
 */
import Skeleton from 'react-loading-skeleton';

const AccountOverviewPlaceholder = () => {
  return (
    <div className='overview__body__table' style={{ display: 'block' }}>
      <Skeleton
        className='overview__body__table__column'
        height={40}
        count={5}
        containerClassName='wallet_table_skeleton_container'
        inline
      />
    </div>
  );
};

export default AccountOverviewPlaceholder;
